import { LivestockAgentAction } from "actions/livestockAgents";
import { SaleyardAdminAction } from "actions/saleyardAdmins";

import { ApiModel } from "constants/loading";
import {
  DeploymentPermission,
  LivestockAgentPermission,
  SaleyardAdminPermission,
  SaleyardPermission,
} from "constants/permissions";
import {
  LIVESTOCK_AGENT_CONTENT_TYPE_NAME,
  SALEYARD_ADMIN_CONTENT_TYPE_NAME,
  userTypes,
} from "constants/users";

import {
  getActiveLivestockAgentDeployment,
  getActiveSaleyardAdminSaleyard,
  getLivestockAgents,
  getSaleyardAdmins,
  selectLivestockAgentsAggridData,
  selectSaleyardAdminsAggridData,
} from "selectors";

export const userTypeConfigMap = {
  [userTypes.SALEYARD_ADMIN]: {
    action: SaleyardAdminAction,
    getDataSelector: getSaleyardAdmins,
    tableDataSelector: selectSaleyardAdminsAggridData,
    requiredData: [
      ApiModel.SALEYARD_ADMINS,
      ApiModel.SALEYARDS,
      ApiModel.PERMISSION_GROUPS,
    ],
    updatePermission: SaleyardAdminPermission.update,
    deletePermission: SaleyardAdminPermission.delete,
    createPermission: SaleyardPermission.canAddSaleyardAdmin,
    createPermissionObjectSelector: getActiveSaleyardAdminSaleyard,
    showDeployments: false,
    showSaleyards: true,
  },
  [userTypes.LIVESTOCK_AGENT]: {
    action: LivestockAgentAction,
    getDataSelector: getLivestockAgents,
    tableDataSelector: selectLivestockAgentsAggridData,
    requiredData: [
      ApiModel.LIVESTOCK_AGENTS,
      ApiModel.DEPLOYMENTS,
      ApiModel.PERMISSION_GROUPS,
    ],
    updatePermission: LivestockAgentPermission.update,
    deletePermission: LivestockAgentPermission.delete,
    createPermission: DeploymentPermission.canAddLivestockAgent,
    createPermissionObjectSelector: getActiveLivestockAgentDeployment,
    showDeployments: true,
    showSaleyards: false,
  },
};

export const ContentTypeNames = {
  [userTypes.SALEYARD_ADMIN]: SALEYARD_ADMIN_CONTENT_TYPE_NAME,
  [userTypes.LIVESTOCK_AGENT]: LIVESTOCK_AGENT_CONTENT_TYPE_NAME,
};
